import { useState } from "react";
import { Formik, Form } from "formik";
import { Box, Card, CardContent } from "@mui/material";
import "./InformationCollection.css";
import FormikControl from "../wrapperComponents/FormikControl.js";
import { InformationCollectionSchema } from "../../schema/InformationCollectionSchema.jsx";
import { InformationCollectionModel } from "../../model/InformationCollectionModel";
import { AuthService } from "../../service/AuthService";
import { msgTypes } from "../../constants/msgTypes.js";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const InformationCollection = () => {
  const [initialValue] = useState(
    new InformationCollectionModel()
  );
  const navigate = useNavigate();

  const submitForm = async (values: InformationCollectionModel) => {
    const appId = msgTypes.APP_ID;
    const saltId = msgTypes.SALT_ID;
    const encryptResponse = await AuthService.encrypt(
      JSON.stringify(values),
      appId,
      saltId
    );
    const requestData = { appId: msgTypes.APP_ID, data: encryptResponse };
    const response = await AuthService.checkoutPaymentInit(requestData);
    if (msgTypes.SUCCESS_CODE.includes(response.statusCode)) {
      const splitData = response.data.paymentLink.split("/quickbilpay/");
      const id = splitData[1];
      navigate("/pay/" + id);
      navigate("/quickbilpay/" + id);
    } else {
      toast.error(response.data);
    }
  };

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={initialValue}
        validationSchema={InformationCollectionSchema}
        onSubmit={submitForm}
      >
        {({ isValid, dirty }) => (
          <Box
            display="flex"
            justifyContent="center"
            marginTop={5}
            marginBottom={5}
          >
            <Card>
              <CardContent>
                <Form>
                  <div className="row p-4 ">

                    <div className="col-lg-6 col-md-6">
                      <FormikControl
                        control="textfield"
                        name="appId"
                        label="App Id"
                        placeholder="Enter App Id"
                        requiredField
                      />
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <FormikControl
                        control="textfield"
                        name="orderId"
                        label="Order Id"
                        placeholder="Enter Order Id"
                        requiredField
                      />
                    </div>

                    <div className="col-lg-6 col-md-6">
                      <FormikControl
                        control="textfield"
                        name="amount"
                        label="Amount"
                        placeholder="Enter Amount"
                        requiredField
                      />
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <FormikControl
                        control="textfield"
                        name="custEmail"
                        label="Email"
                        placeholder="Enter Email"
                        requiredField
                      />
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <FormikControl
                        control="textfield"
                        name="custPhone"
                        label="Customer Phone"
                        placeholder="Enter Customer Phone"
                        requiredField
                      />
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <FormikControl
                        control="textfield"
                        name="currencyCode"
                        label="Currency Code"
                        placeholder="Enter Currency Code"
                        requiredField
                      />
                    </div>

                    <div className="col-lg-6 col-md-6">
                      <FormikControl
                        control="textfield"
                        name="returnUrl"
                        label="Return Url"
                        placeholder="Enter Return URL"
                        requiredField
                      />
                    </div>

                    <div className="col-lg-6 col-md-6">
                      <FormikControl
                        control="textfield"
                        name="transactionType"
                        label="Transaction Type"
                        placeholder="Enter Transaction Type"
                        requiredField
                      />
                    </div>

                    <div className="col-lg-6 col-md-6">
                      <FormikControl
                        control="textfield"
                        name="productDesc"
                        label="Product Description"
                        placeholder="Enter Product Description"
                        requiredField
                      />
                    </div>

                    <div className="col-12 mt-3 d-flex justify-content-end">
                      <FormikControl
                        control="button"
                        className="btn-submit btn"
                        color="primary"
                        label="Submit"
                        type="submit"
                        disabled={!dirty || !isValid}
                      />
                      &nbsp;&nbsp;
                      <FormikControl
                        control="button"
                        className="btn-cancel btn"
                        color="warning"
                        label="Reset"
                        type="reset"
                      />
                    </div>
                  </div>
                </Form>
              </CardContent>
            </Card>
          </Box>
        )}
      </Formik>
    </>
  );
};

export default InformationCollection;
